import { useEffect } from 'react';
import { useLayoutEditorContext } from '../../../../hooks/context/useLayoutEditorContext';

// Any pointer-down outside the focused field's panel item drops the field
// focus (and with it the canvas overlay). A blur alone is not enough: Ionic
// panel surfaces can swallow the click without moving the focus, and Konva
// prevents the default mousedown entirely. Pointer-down capture fires
// regardless of both. Canvas clicks in the popped-out window (separate
// document) are handled by the stage pointer-down instead.
export const useFocusedFieldOutsideRelease = (): void => {
  const { focusedObjectField, setFocusedObjectField } =
    useLayoutEditorContext();

  useEffect(() => {
    if (!focusedObjectField) {
      return;
    }

    const handlePointerDown = (event: PointerEvent): void => {
      const target = event.target;
      const item =
        target instanceof Element ? target.closest('[data-form-field]') : null;

      // Clicks inside the focused field's own item (input, stepper, label)
      // keep the overlay.
      if (
        item instanceof HTMLElement &&
        item.dataset.formField === focusedObjectField
      ) {
        return;
      }

      setFocusedObjectField(null);
    };

    document.addEventListener('pointerdown', handlePointerDown, true);

    return () =>
      document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [focusedObjectField]);
};
